import React from "react";
import QRCode from "react-qr-code";
import { Container } from "reactstrap";
import withRouter from "../../Components/Common/withRouter";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

const QrCode = () => {
  const link = `${process.env.REACT_APP_URL_QRCODE}`;
  document.title = "Fila de atendimento :: QR Code";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="flex-grow-1" style={{ textAlign: "center" }}>
          <h2>QrCode</h2>
        </div>
        <div className="page-content landing" style={{ paddingTop: 50 }}>
          <Container fluid>
            <QRCode
              viewBox={`0 0 256 256`}
              value={link}
              size={256}
              style={{ width: "100%" }}
            />
          </Container>
          <div
            className="flex-grow-1"
            style={{ textAlign: "center", paddingTop: 50 }}
          >
            <h2>{link}</h2>
          </div>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(QrCode);
